export default {
    setZCierres(state, a) {
        state.zcierres = a;
    }
}